import {
  CIS_CHIP_BEHAVIORS,
  CIS_CHIP_TYPES,
  IChipSearchFilterElement,
} from '@el-chip-input-search';
import { TranslateService } from '@ngx-translate/core';

import { INVENTORY_STATUS } from '@shared/constants';

function statusDropDown(translateService: TranslateService) {
  return [
    {
      key: translateService.instant('inventory.search.available'),
      value: INVENTORY_STATUS.AVAILABLE,
    },
    {
      key: translateService.instant('inventory.search.decommissioned'),
      value: INVENTORY_STATUS.DECOMMISSIONED,
    },
    {
      key: translateService.instant('inventory.search.allocated'),
      value: INVENTORY_STATUS.ALLOCATE,
    },
  ];
}

function categoryDropDown(asset_category: string[]) {
  const array: { key: string; value: string }[] = [];

  asset_category.forEach((cat) => {
    array.push({
      key: cat,
      value: cat,
    });
  });
  return array;
}

export function getAllCISChipsList(
  translateService: TranslateService,
  asset_category: string[]
) {
  return [
    {
      name: translateService.instant('inventory.search.name'),
      chipProperties: {
        type: CIS_CHIP_TYPES.TEXT,
        key: 'assetId',
        placeholder: translateService.instant('inventory.search.name'),
      },
      behavior: CIS_CHIP_BEHAVIORS.DEFAULT,
    },
    {
      name: translateService.instant('inventory.search.status'),
      chipProperties: {
        type: CIS_CHIP_TYPES.SELECT,
        key: 'status',
        properties: {
          options: statusDropDown(translateService),
        },
      },
      behavior: CIS_CHIP_BEHAVIORS.DEFAULT,
    },
    {
      name: translateService.instant('inventory.search.available-category'),
      chipProperties: {
        type: CIS_CHIP_TYPES.SELECT,
        key: 'category',
        properties: {
          options: categoryDropDown(asset_category),
        },
      },
      behavior: CIS_CHIP_BEHAVIORS.DEFAULT,
    },
  ] as IChipSearchFilterElement[];
}
